const riot = require('riot');

riot.tag2('popup-select', '<div class="w266 bg-white" ref="popup"> <div class="pb16 border-bottom border-separator_opaque overflow-scroll scrollbar-none" riot-style="max-height: {opts.options() ? 208 : 0}px"> <div class="w-full" data-is="item-selection-list" each="{option in items}" onclick="{onClickSelect}"> <div class="f fm px12 py8 cursor-pointer" if="{parent.opts.kind === &quot;project&quot;}"> <div class="flex-fixed s8 circle mr4" riot-style="background-color: {option.data.color || app.utils.defaultColor};"></div> <div riot-style="color: {option.data.color || app.utils.defaultColor};">{option.data.name}</div> </div> <div class="f fm px12 py8 cursor-pointer" if="{parent.opts.kind === &quot;user&quot;}"><img class="block object-fit-cover s16 circle pointer-none mr4" if="{option.data.icon_url}" riot-src="{option.data.icon_url}"> <div class="text-label_high">{option.data.screen_name}</div> </div> </div> </div> <div data-is="item-selection-list" if="{opts.kind === &quot;project&quot;}" onclick="{selectNewProject}"> <div class="f fh py10 text-primary"><i class="icon-add fs16 mr2"></i> <div class="fs12 lh15">プロジェクトを追加</div> </div> </div> </div>', 'popup-select,[data-is="popup-select"]{display:block}', 'class="bg-white box-shadow rounded-8 border overflow-hidden"', function(opts) {
    this.isSelect = false;

    this.on('mount', () => {
      this.setItems();
    });

    this.setItems = () => {
      this.items = this.opts.options();
      this.update();
    };

    this.mixin('selectionList');

    this.select = (option) => {
      this.trigger('select', {option});
      this.close();
    };

    this.onClickSelect = (e) => {
      this.select(e.item.option);
    };

    this.selectNewProject = () => {
      this.select({ id: 'new', data: { name: '' } });
    };

    this.onDeleteQuery = () => {
      this.refs.search.value = '';
      this.debounceSearch();
      this.update();
    };

    this.on('selectionList.keydown.enter', (e) => {
      e.preventDefault();
      this.selectCurrent();
    });

    this.selectCurrent = () => {
      if (this.isSelect) return;
      this.isSelect = true;
      var index = this.selectionList.selectedIndex;

      if (index !== 0 && this.items.length <= index && this.opts.kind === 'project') {
        this.selectNewProject();
        return ;
      }
      this.select(this.items[index]);
      this.isSelect = false;
    };
});